import { Bot } from 'lucide-react'
import type { TelegramBot } from '@/api/hooks/useTelegram'

export function BotSelector({ bots, value, onChange }: { bots: TelegramBot[]; value: string | null; onChange: (id: string) => void }) {
  if (bots.length <= 1) return null

  return (
    <div className="flex items-center gap-2">
      <Bot className="h-4 w-4 text-muted-foreground" />
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        className="px-3 py-1.5 bg-background border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary"
      >
        {bots.map((bot) => (
          <option key={bot.id} value={bot.id}>@{bot.bot_username}</option>
        ))}
      </select>
    </div>
  )
}
